<template>
	<v-card flat class="pa-3">
		<div class="d-flex flex-wrap ga-3 align-center">
			<v-autocomplete
				:model-value="modelValue.userUuid"
				:items="userOptions"
				item-title="email"
				item-value="uuid"
				label="User"
				variant="outlined"
				density="compact"
				hide-details
				auto-select-first
				clearable
				class="activity-filter-select flex-grow-0"
				@update:model-value="(v) => emitPatch('userUuid', v)"
			/>

			<v-autocomplete
				:model-value="modelValue.projectUuid"
				:items="projectOptions"
				item-title="name"
				item-value="uuid"
				label="Project"
				variant="outlined"
				density="compact"
				hide-details
				auto-select-first
				clearable
				class="activity-filter-select flex-grow-0"
				@update:model-value="(v) => emitPatch('projectUuid', v)"
			/>

			<v-menu v-model="dateMenus.startDate" :close-on-content-click="false">
				<template #activator="{ props }">
					<v-text-field
						v-bind="props"
						:model-value="modelValue.startDate"
						label="From"
						variant="outlined"
						density="compact"
						hide-details
						readonly
						clearable
						prepend-inner-icon="mdi-calendar"
						class="activity-filter-date flex-grow-0"
						@click:clear="emitPatch('startDate', null)"
					/>
				</template>
				<v-date-picker
					:model-value="pickerDate(modelValue.startDate)"
					:max="pickerDate(modelValue.endDate)"
					color="primary"
					hide-header
					@update:model-value="(v) => pickDate('startDate', v)"
				/>
			</v-menu>

			<v-menu v-model="dateMenus.endDate" :close-on-content-click="false">
				<template #activator="{ props }">
					<v-text-field
						v-bind="props"
						:model-value="modelValue.endDate"
						label="To"
						variant="outlined"
						density="compact"
						hide-details
						readonly
						clearable
						prepend-inner-icon="mdi-calendar"
						class="activity-filter-date flex-grow-0"
						@click:clear="emitPatch('endDate', null)"
					/>
				</template>
				<v-date-picker
					:model-value="pickerDate(modelValue.endDate)"
					:min="pickerDate(modelValue.startDate)"
					color="primary"
					hide-header
					@update:model-value="(v) => pickDate('endDate', v)"
				/>
			</v-menu>

			<v-btn variant="outlined" size="small" @click="$emit('reset')">
				Reset
			</v-btn>
		</div>
	</v-card>
</template>

<script>
import { toLocalDateString } from "@/pages/ActivityMetrics/constants";

export default {
	name: "ActivityFilters",

	props: {
		modelValue: {
			type: Object,
			required: true,
		},
		userOptions: {
			type: Array,
			default: () => [],
		},
		projectOptions: {
			type: Array,
			default: () => [],
		},
	},

	emits: ["update:modelValue", "reset"],

	data() {
		return {
			// Open state per picker menu, so picking a date can close its menu
			// (the default keeps it open, an explicit UX complaint last time).
			dateMenus: {
				startDate: false,
				endDate: false,
			},
		};
	},

	methods: {
		// The filter object is owned by the page; children patch single keys so
		// one changed filter never clobbers the rest of the state.
		emitPatch(key, value) {
			this.$emit("update:modelValue", {
				...this.modelValue,
				[key]: value || null,
			});
		},

		// The picker wants a Date; the filter holds a local YYYY-MM-DD string.
		// Parse the parts numerically - new Date("YYYY-MM-DD") reads as UTC
		// midnight and can land on the wrong local day.
		pickerDate(dateStr) {
			if (!dateStr) {
				return null;
			}
			const [year, month, day] = dateStr.split("-").map(Number);
			return new Date(year, month - 1, day);
		},

		pickDate(key, value) {
			this.dateMenus[key] = false;
			// Back to a LOCAL YYYY-MM-DD string; toLocalDateString reads local
			// date parts, never the UTC-shifted toISOString() day.
			this.emitPatch(key, value ? toLocalDateString(value) : null);
		},
	},
};
</script>

<style scoped>
.activity-filter-select {
	width: 220px;
}

.activity-filter-date {
	width: 210px;
}
</style>
